import { isActiveFlag } from './flag'
import * as debugKeys from './debugKeys'
import * as debugDefaults from './applicationDebugUtil'

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default { isActiveFlag, ...debugKeys, ...debugDefaults }
